import {
  SET_ATTACHMENT_TEXT_PENDING,
  UPLOAD_ATTACHMENT_TEXT_SUCCESS,
} from '../actions/AttachmentsActions';

export default (state = {}, action) => {
  switch (action.type) {
    case SET_ATTACHMENT_TEXT_PENDING:
      return {
        ...state,
        pending: action.payload,
      };
    case UPLOAD_ATTACHMENT_TEXT_SUCCESS: {
      const { attachmentId, text } = action.payload;

      return {
        ...state,
        pending: false,
        texts: {
          ...(state.texts ?? {}),
          [attachmentId]: text,
        },
      };
    }
    default:
      return state;
  }
};
